import React from 'react';

import PropTypes from 'prop-types';

import * as APPSTYLE from '@/constants/pcConstAppStyle';

// import ToggleButtonCustom from './src/ToggleButtonCustom.jsx/index';
import ToggleButtonCustom from './src/ToggleButtonCustom';

import './ToggleButton.less';

class ToggleButtonLabel extends React.Component {
  shouldComponentUpdate(nextProps) {
    const {label, defaultValue, value, onClick, disabled} = this.props;
    if (label !== nextProps.label) return true;
    if (defaultValue !== nextProps.defaultValue) return true;
    if (value !== nextProps.value) return true;
    if (onClick !== nextProps.onClick) return true;
    if (disabled !== nextProps.disabled) return true;
    return false;
  }

  disableButtonProps = () => {
    const {buttonProp, disabled} = this.props;
    const newProps = buttonProp;
    if (newProps && newProps.length > 0) {
      for (let i = 0; i < newProps.length; i++) {
        newProps[i].disabled = disabled;
      }
    }
    return newProps;
  };

  render() {
    const {label, buttonProp, defaultValue, value, onClick, disabled, ...otherProps} = this.props;
    const onClickCallback = disabled ? undefined : onClick;
    const classLabel = label === undefined ? 'displayLabel' : `${APPSTYLE.COLUMN_LABEL_NORMAL}paddingClass `;
    const classToggle =
      label === undefined
        ? `${APPSTYLE.COLUMN_FULL}no-padding colToggleButton `
        : `${APPSTYLE.COLUMN_LABEL_FULL_WIDTH}no-padding colToggleButton `;
    const newProps = this.disableButtonProps();
    return (
      <div className="middleAlign">
        {label && (
          <div className={classLabel}>
            <div className="row row-margin">
              <span
                className="togleButtonLabel"
                disabled={disabled}
              >
                {label}{' '}
              </span>
            </div>
          </div>
        )}
        <div className={classToggle}>
          <ToggleButtonCustom
            buttonProp={newProps}
            defaultValue={defaultValue}
            value={value}
            onClick={onClickCallback}
            disabled={disabled}
            className="table-cell-gap"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...otherProps}
          />
        </div>
      </div>
    );
  }
}

ToggleButtonLabel.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  buttonProp: PropTypes.array,
};

ToggleButtonLabel.defaultProps = {
  onClick: () => {},
  id: '',
  label: '',
  disabled: false,
  defaultValue: null,
  value: null,
  buttonProp: [],
};

export default ToggleButtonLabel;
